import * as React from 'react';
import styles from './styles.module.scss';
import { DataTableBodyProps } from './types';

export const DataTableBody: React.FC<DataTableBodyProps> = ({
  zebra,
  children
}: React.PropsWithChildren<DataTableBodyProps>) => (
  <tbody className={`${zebra ? styles.zebra : ''}`}>{children}</tbody>
);
